import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-139">
      {label && <label className="block text-sm font-medium text-gray-300 mb-1" data-id="element-140">
          {label}
        </label>}
      <input className={`w-full px-3 py-2 bg-dark-lighter border rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-colors
          ${error ? 'border-red-500' : 'border-gray-700 text-white placeholder-gray-500'}
          ${className}`} {...props} data-id="element-141" />
      {error && <p className="mt-1 text-xs text-red-500" data-id="element-142">{error}</p>}
    </div>;
}